import { render, staticRenderFns } from "./bindCard.vue?vue&type=template&id=b418f010&scoped=true"
import script from "./bindCard.vue?vue&type=script&lang=js"
export * from "./bindCard.vue?vue&type=script&lang=js"
import style0 from "./bindCard.vue?vue&type=style&index=0&id=b418f010&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b418f010",
  null
  
)

export default component.exports